import "./index.less";
import * as React from "react";
import { BaseAtScale } from "../BaseAtScale";
import { BaseAtScaleGroup } from "../BaseAtScaleGroup";
import { H3SectionLayout } from "../../AtDocumentLayout";
import { PrintModeEnum, ScaleType } from "@atman/business";
import { STANINE_SCALE_SEPARATORS } from "../../AtGenericScales";

export interface IAtUnipolarScaleGroupProps {
    scaleLabels?: string[];
    isCompetencyGroup?: boolean;
    showUnipolarScaleAsBipolar?: boolean;
    showDenominator?: boolean;
    printMode?: PrintModeEnum;
    onViewCandidateDetailClick?: (candidateProId: string) => void;
}

export class AtUnipolarScaleGroup extends BaseAtScaleGroup<IAtUnipolarScaleGroupProps> {
    render() {
        const {
            dimensionGroup,
            maxScore,
            assessmentType,
            distributionData,
            distributionViewMode,
            showDistribution,
            distributionMembers,
            expandedDimension,
            onExpandedDimensionChange,
            showUnipolarScaleAsBipolar = false,
            showHeader = true,
            showDescription = true,
            showFitIndicators,
            interpretationDataEntries,
            printMode,
            showDenominator = false,
            displayCompact = false,
            onViewCandidateDetailClick,
        } = this.props;

        let additionalClasses: string = "AtUnipolarScaleGroup";
        if (printMode === PrintModeEnum.Detailed) {
            additionalClasses += " detailed";
        }

        return (
            <H3SectionLayout
                id={this.id}
                title={dimensionGroup.name}
                description={dimensionGroup.description}
                showDescription={showDescription}
                className={additionalClasses}
                showHeader={showHeader}
            >
                {dimensionGroup.dimensions.map((x) => (
                    <BaseAtScale
                        key={x.enumName}
                        scaleType={showUnipolarScaleAsBipolar ? ScaleType.Bipolar : ScaleType.Unipolar}
                        dimension={x}
                        maxScore={maxScore}
                        assessmentType={assessmentType}
                        scores={this.getScoresForDimension(x.enumName)}
                        distributionMembers={distributionMembers}
                        distributionEntries={distributionData?.getEntriesForDimension(x.enumName.toCamel())}
                        distributionAverage={distributionData?.getAverageForDimension(x.enumName.toCamel())}
                        // fitScore={this.getFitScore(x)}
                        // analyzedCandidateScore={analyzedCandidateScores?.hasOwnProperty(x.enumName.toCamel()) ? analyzedCandidateScores[x.enumName.toCamel()] : undefined}
                        interpretationData={interpretationDataEntries?.get(x.enumName.toCamel())}
                        distributionViewMode={distributionViewMode}
                        showDistribution={showDistribution}
                        expandedDimension={expandedDimension}
                        onExpandedDimensionChange={onExpandedDimensionChange}
                        showFitIndicators={showFitIndicators}
                        printMode={printMode}
                        // currentFitLevelFilter={currentFitLevelFilter}												                                         key={x.enumName}
                        showDenominator={showDenominator}
                        displayCompact={displayCompact}
                        onViewCandidateDetailClick={onViewCandidateDetailClick}
                        separators={STANINE_SCALE_SEPARATORS}
                    />
                ))}
            </H3SectionLayout>
        );
    }
}
